/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2023-02-09 10:28:13
 */
import React, { useCallback, useState, useRef } from 'react';
import { useIntl } from 'react-intl';

import messages from '../messages';
import { Tooltip, Badge } from 'sup-ui';
import Icon from 'root/components/Icon';

import styles from '../index.less';

interface IProps {
  capacityData: {
    ip?: string;
    actualTotal?: string;
    free?: string | number;
    location?: string;
    lvTotal?: string;
    otherUsed?: string | number;
    packUsed?: string | number;
    vgName?: string;
  };
}

const Detail = (props: IProps) => {
  const intl = useIntl();

  const parentWidth = useRef<any>({});
  const [falg, setFlag] = useState(false);

  const { capacityData: { packUsed = 0, otherUsed = 0, location = '/', free = 0, ip = '', actualTotal = 0 } = {} } =
    props;

  const fatherRef = useCallback(
    (node: any) => {
      if (node !== null) {
        const number: any = node.getBoundingClientRect().width;
        const name = node.dataset.name;

        parentWidth.current[name] = number;
        setFlag(!falg);
      }
    },
    [otherUsed, packUsed],
  );

  return (
    <div className={styles.package_manage_detail}>
      <div className={styles.title}>
        <Tooltip className={styles.title_name} title={intl.formatMessage(messages.groupServer, { ip })}>
          {intl.formatMessage(messages.groupDiskName)}
          <Icon type="tip16" style={{ marginLeft: 5, fontSize: 16 }} />
        </Tooltip>
        <div className={styles.title_count}>
          {free}GB {intl.formatMessage(messages.useable)}({intl.formatMessage(messages.total)} {actualTotal}GB)
        </div>
        <div className={styles.title_position}>
          {intl.formatMessage(messages.packPosition)}: {location}
        </div>
      </div>
      <div className={styles.capacity}>
        {packUsed > 0 && (
          <div
            title={`${intl.formatMessage(messages.packUsed)}:${packUsed}GB`}
            className={`${styles.packItem} ${parentWidth.current.packUsed > 50 ? styles.showTitle : ''}`}
            style={{ width: `${(Number(packUsed) / Number(actualTotal)) * 100}%` }}
            ref={fatherRef}
            data-name="packUsed"
          >
            <span
              style={{
                visibility: parentWidth.current.packUsed > 50 ? 'visible' : 'hidden',
              }}
            >
              {intl.formatMessage(messages.packUsed)}: {packUsed}GB
            </span>
          </div>
        )}
        {otherUsed > 0 && (
          <div
            title={`${intl.formatMessage(messages.otherUsed)}:${otherUsed}GB`}
            className={`${styles.otherItem} ${parentWidth.current.otherUsed > 50 ? styles.showTitle : ''}`}
            style={{ width: `${(Number(otherUsed) / Number(actualTotal)) * 100}%` }}
            ref={fatherRef}
            data-name="otherUsed"
          >
            <span
              style={{
                visibility: parentWidth.current.otherUsed > 50 ? 'visible' : 'hidden',
              }}
            >
              {intl.formatMessage(messages.otherUsed)}: {otherUsed}GB
            </span>
          </div>
        )}
      </div>

      <div className={styles.packSpot}>
        <Badge color="#2280fa" text={intl.formatMessage(messages.packUsed)} />
        <Badge color="#a8afb6" text={intl.formatMessage(messages.otherUsed)} />
      </div>
    </div>
  );
};

export default Detail;
